import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { ICorporatePartner } from '../../models/corporate-partner/corporate-partner.interface';
import { getCorporatePartner } from '../../utils/corporate-method/corporate-partner.method';
import { SwitchingAccountExtendedService } from './switching-account-extended.service';
@Injectable({
  providedIn: 'root'
})
export class SwitchingAccountService extends SwitchingAccountExtendedService {
  corporatePartnerChange: BehaviorSubject<ICorporatePartner> =
    new BehaviorSubject<ICorporatePartner>({} as ICorporatePartner);

  displayBody: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  setInitialBusinessType(corporateName: string): void {
    this.setInitialBusinessTypeHelper(corporateName);
  }

  updateAccountInfo(corporateName: string, resData: string): void {
    const { types, contractMgtEnt, program, id } =
      this.extractValuesFromResponse();

    if (this.isValidResponse(types, contractMgtEnt, program)) {
      this.setAdditionalBusinessUserInfo(
        ...this.getValuesAtIndex(types, contractMgtEnt, program, id, resData)
      );
    }

    this.updateCorporateName(corporateName);
    this.handleCookie();
  }

  setInitialBusinessTypeHelper(corporateName: string): void {
    this.handleCookie();
    this.userSession
      .getUserSession()
      .pipe(take(1))
      .subscribe((res) => {
        this.dashboardResponse = res;
        if (res && res.crprtAgrmntTypeCode) {
          this.profileSelector
            .getAccountType('edpCorpData')
            .pipe(take(1))
            .subscribe(
              (resData: { cacheKey: string; value: string }) => {
                if (resData) {
                  if (resData && resData.value !== 'P') {
                    this.updateAccountInfo(corporateName, resData.value);
                  }
                }
              },
              (error) => {
                this.logging.log(error);
                const cookieObject = Object.assign(
                  {},
                  { hasCookie: this.cookieHelper.getCookies('corp') }
                );
                if (cookieObject.hasCookie) {
                  this.handleDefaultCase();
                } else {
                  this.profileSelector
                    .postAccountTypeCall('P')
                    .pipe(take(1))
                    .subscribe(
                      () => {
                        this.setRestrictToPersonal();
                      },
                      (error) => {
                        this.logging.log(error);
                        this.setRestrictToPersonal();
                      }
                    );
                }
              }
            );
        }
      });
  }

  setRestrictToPersonal(): void {
    this.businessAccount = false;
    this.cookieHelper.setCookieName('restrictToPersonal', 'personal', 0, true);
    this.toggleAccount(this.businessAccount, false);
  }

  handleDefaultCase(): void {
    const corpName = this.getCorpNameFromCookies();
    this.businessUser = true;
    this.intranetLink = true;
    this.accountName = corpName;
    this.toggleAccount(true, false);
    this.setCorporateName(corpName);
  }

  toggleAccount(
    selectedBusinessAccountFlag: boolean,
    showCorporateForNonLoggedIn: boolean
  ): void {
    const hasCorpCookie = this.cookieHelper.getCookies('corp');
    if (selectedBusinessAccountFlag) {
      if (hasCorpCookie) {
        this.businessAccount = true;
        this.partnerId = 'edp';
      } else {
        this.toggleAccountHelper();
      }
    } else {
      this.businessAccount = showCorporateForNonLoggedIn;
    }
    this.getOtherAccountDetailsFromCookie(hasCorpCookie);
    this.displayCorporateName = '';
    this.corpPartner = getCorporatePartner(this.partnerId);
    this.corporatePartnerChange.next(this.corpPartner);
  }

  showSwitching(): void {
    this.display = true;
    this.displayBody.next(this.display);
  }

  hideSwitching(): void {
    this.display = false;
    this.displayBody.next(this.display);
    setTimeout(() => {
      const switchAccount = document.getElementById('switch-account-overlay');
      if (switchAccount) {
        switchAccount.click();
      }
    }, 100);
  }
}
